import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import DropdownActivator from 'scaleflow/utils/dropdown-activate';
import nameSort from 'scaleflow/utils/nameSort';
import type StoreService from 'scaleflow/services/store';
import type IdeaModel from 'scaleflow/models/idea';
import type InitiativeModel from 'scaleflow/models/initiative';

export interface DropdownActivatorSignature {
  Args: {
    idea: IdeaModel;
  };
  Blocks: {
    default: [];
  };
  Element: null;
}

export default class IdeasTableCellInitiativesComponent extends DropdownActivator<DropdownActivatorSignature> {
  @service declare store: StoreService;
  @tracked initiativeFormIsVisible = false;
  selectedIdea: null | IdeaModel = null;

  get idea() {
    return this.args.idea;
  }

  @action
  handleInitiativesChange(idea: IdeaModel, e: string[]) {
    const initiatives = e.map((id) => this.store.peekRecord('initiative', id));
    idea.set('initiatives', initiatives);
    void idea.save();
  }

  @action
  toggleInitiativeForm(idea: IdeaModel, val?: boolean) {
    if (idea) this.selectedIdea = idea;
    else this.selectedIdea = null;
    if (val !== undefined) this.initiativeFormIsVisible = val;
    else this.initiativeFormIsVisible = !this.initiativeFormIsVisible;
  }

  @action
  async onInitiativeAdded(initiative: InitiativeModel) {
    const initiatives = await this.selectedIdea!.initiatives;
    initiatives.pushObject(initiative);
    await this.selectedIdea!.save();
  }

  get initiativesList() {
    const initiatives = this.store
      .peekAll<InitiativeModel>('initiative')
      .map((item: InitiativeModel) => ({
        value: item.id,
        label: item.title,
      }));
    return initiatives;
  }

  get sortedInitiatives() {
    const data = this.idea.initiatives?.content as Array<InitiativeModel>;
    return data
      .slice()
      .sort((a: InitiativeModel, b: InitiativeModel) =>
        nameSort(a.title, b.title, 'asc'),
      );
  }

  get firstInitiative() {
    return this.sortedInitiatives?.[0];
  }

  willDestroy() {
    this.initiativeFormIsVisible = false;
    this.selectedIdea = null;
    super.willDestroy();
  }
}
